module.exports = __webpack_public_path__ + "img/fig02.a90b0d56.jpg";